import {clamp} from "./clamp";

export function inRange(min: number, max: number ) {
    return (val: number) => clamp(val, min, max);
}